<template>
  <div class="help-content">
    <div
      class="help-item"
      v-for="(item, index) in list"
      :key="index"
      @click="onClick(item)"
      v-show="item.countrys.includes(country)"
    >
      <i v-if="item.name != 'License'" :class="`${item.icon} help-icon`"></i>
      <img v-else-if="country == 'ET'" class="icon" :src="`${resBaseUrl}icon_21.png`" alt="" />
      <img v-else class="icon" :src="`${resBaseUrl}icon_18.png`" alt="" />
      <span class="help-item-name">
        <!-- :style="`width: ${item.width};`" -->
        {{ item.name }}
      </span>
    </div>
    <div style="width: 43%"></div>
  </div>
</template>

<script>
import { config } from '@/common/config'
import { useUserStore } from '@/stores/user'
import { mapState } from 'pinia'

export default {
  data() {
    return {
      resBaseUrl: config.resBaseUrl,
      list: [
        {
          icon: 'bi bi-telegram',
          name: 'Telegram',
          navType: 1,
          width: '1rem',
          navValue: 'https://t.me/+IiJeb9mFiD00Nzc1',
          countrys: ['ET']
        },
        {
          icon: 'bi bi-wallet2',
          name: 'How to Deposit',
          navType: 2,
          width: '1rem',
          navValue: '/howtodeposit',
          countrys: ['ET', 'CI', 'KE']
        },
        {
          icon: 'bi bi-cash-stack',
          name: 'How to Withdraw',
          navType: 2,
          width: '1rem',
          navValue: '/howtowithdraw',
          countrys: ['ET', 'CI', 'KE']
        },
        {
          icon: 'bi bi-bootstrap',
          name: 'Bonus',
          navType: 2,
          width: '1rem',
          navValue: '/bonus',
          countrys: ['ET', 'CI', 'KE']
        },
        {
          icon: 'bi bi-envelope',
          name: 'support@vivagame.et',
          navType: 3,
          width: '3.35rem',
          navValue: 'support@vivagame.et',
          countrys: ['ET']
        },
        {
          icon: 'bi bi-envelope',
          name: 'License',
          /** 
           * <img v-if="country == 'ET'" class="icon" :src="`${resBaseUrl}icon_21.png`" alt="" />
           * <img v-else class="icon" :src="`${resBaseUrl}icon_18.png`" alt="" />
           */
          navType: 2,
          width: '3.35rem',
          navValue: '/license',
          countrys: ['ET','KE','CI','GH','NG','TZ']
        }
      ]
    }
  },
  computed: {
    ...mapState(useUserStore, ['country'])
  },
  methods: {
    onClick(item) {
      console.log('item=====>>>>>>', item)
      switch (item.navType) {
        case 1:
          window.open(item.navValue, '_blank')
          break
        case 2:
          this.$router.replace(item.navValue)
          break
        // case 3:
        // const email = item.navValue; // 收件人邮箱
        // const subject = '';          // 邮件主题
        // const body = '';    // 邮件正文

        // 生成 mailto 链接
        // const mailtoLink = `mailto:${email}`;// ?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}

        // 使用 window.location.href 进行跳转
        // window.location.href = mailtoLink;
        // break;
        default:
          break
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.help-content {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 25px;
  /* 设置子元素间的间距 */
  width: 90%;
  height: auto;
  padding: 0 5%;
  justify-content: center;

  .help-item {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0.05rem 0.1rem;
    border: 1px solid #324559;
    // border-radius: 0.16rem;
    width: 40%;
    height: 0.6rem;
    background: #324559;
    border-radius: 0.12rem 0.12rem 0.12rem 0.12rem;

    .help-icon {
      font-size: 0.3rem;
      margin-right: 0.1rem;
      color: #ffffff;
    }

    .help-item-name {
      font-size: 0.24rem;
      color: #ffffff;
      line-height: 0.33rem;
      margin-left: 0.1rem;
      width: auto;
    }

    img{
      width: 0.4rem;
      filter: brightness(0) invert(1); /* 添加白色滤镜 */
    }
  }
}
</style>
